import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

type DeleteApplicationModalProps = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  isLoading: boolean;
};

export const DeleteApplicationModal: FC<DeleteApplicationModalProps> = (props) => {
  const { open, onClose, onDelete, isLoading } = props;
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { minWidth: '380px' } }}>
      <DialogTitle>{t('abf-pay-apps.modals.delete.title')}</DialogTitle>
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>{t('abf-pay-apps.modals.delete.text')}</DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={() => onDelete()} disabled={isLoading}>
          {t('abf-pay-apps.modals.delete.delete-btn')}
        </Button>
        <Button variant="outlined" onClick={() => onClose()}>
          {t('abf-pay-apps.modals.cancel-btn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
